import { useMemo } from "react"
import { useSubscription } from "react-relay"
import { graphql, GraphQLSubscriptionConfig } from "relay-runtime"
import { usePartnerInVideoCallChannelSubscription as UsePartnerInVideoCallChannelSubscriptionType } from "@/modules/video-call/services/__generated__/usePartnerInVideoCallChannelSubscription.graphql"

const partnerInVideoCallChannelSubscription = graphql`
  subscription usePartnerInVideoCallChannelSubscription {
    partnerInVideoCallChanged {
      appointmentId
      isPartnerInVideoCall
    }
  }
`

const usePartnerInVideoCallChannel = () => {
  const config = useMemo<GraphQLSubscriptionConfig<UsePartnerInVideoCallChannelSubscriptionType>>(
    () => ({
      variables: {},
      subscription: partnerInVideoCallChannelSubscription,
      updater: (store, data) => {
        const evt = data?.partnerInVideoCallChanged
        if (!evt) return
        const record = store.get(evt.appointmentId)
        if (!record) return
        record.setValue(evt.isPartnerInVideoCall, "isPartnerInVideoCall")
      },
      onError: (error: Error) =>
        console.error("An error occurred while subscribing to PartnerInVideoCallChanged:", error),
    }),
    [],
  )

  useSubscription<UsePartnerInVideoCallChannelSubscriptionType>(config)
}

export { usePartnerInVideoCallChannel }
